import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { GenerarArchivoEndosoPmsInterface } from "../interface/GenerarArchivoEndosoPms.interface";
import { FileDto } from "../../../../dtos/FileDto";


const downloadFileEndosoPms = async (data: GenerarArchivoEndosoPmsInterface): Promise<AxiosResponse<FileDto>> => {
    const body = { rutInversionista: data.rutInversionista, fechaEmision: data.fechaEmision.toISOString().split('T')[0] };
    const response = await axiosInstance.post(`siscred-api-reportes/v1/archivo-externo/generareporteendosopms`, body);
    return response;
}

export {
    downloadFileEndosoPms
}
